module.exports = __webpack_public_path__ + "static/img/gzh2.01e58fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gzh2.jpg
// module id = 19tW
// module chunks = 1